import { useMatch } from "react-router"

export const NoFSID = 0

export const useFSId = () => {
  const match = useMatch('/main/projects/:projectId/:type/:id')
  return match?.params.id ? Number(match?.params.id) : NoFSID
}